/*
 * @Author: liujiang liujiang@shjinjia.com.cn
 * @Date: 2022-07-13 11:09:31
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2023-10-23 11:24:39
 * @FilePath: \oak\src\store\modules\routerMap\views\stockcontrol.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 采购
const map = {
  expectedShortage: () => import('@/views/stockcontrol/ExpectedShortage'),
  lowVolumeSales: () => import('@/views/stockcontrol/lowVolumeSales'),
  newProductList: () => import('@/views/stockcontrol/NewProductList'),
  suppliersList: () => import('@/views/stockcontrol/SuppliersList'),
  stockoutList: () => import('@/views/stockcontrol/StortockTab'), // tab页面缺货一览和缺货补给
  recentlyArrivalList: () => import('@/views/stockcontrol/RecentlyArrivalList'),
  shopStockOutList: () => import('@/views/stockcontrol/ShopStockOutList'),
  brandVirtualSingle: () => import('@/views/stockcontrol/BrandVirtualSingle'),
  brandVirtualSingleDetail: () =>
    import('@/views/stockcontrol/BrandVirtualSingleDetail'),
  merchantSupplier: () => import('@/views/stockcontrol/MerchantSupplier'),
  sellingAbnormal: () => import('@/views/stockcontrol/SellingAbnormal'), // 销售异常商品
  purchaseList: () => import('@/views/stockcontrol/PurchaseList'),
  purchaseOrderFreightManagement: () =>
    import('@/views/stockcontrol/PurchaseOrderFreightManagement'),
  inventoryAllocationList: () =>
    import('@/views/stockcontrol/InventoryAllocationList'), //  入库分摊列表
  expensesList: () => import('@/views/stockcontrol/ExpensesList'), //  费用单列表
  salesAllocationList: () => import('@/views/stockcontrol/SalesAllocationList'), //  销售分摊列表
  costReductionTableList: () => import('@/views/stockcontrol/costReduction/CostReductionTableList'), // 降本基准价审批
  createCostReduction: () => import('@/views/stockcontrol/costReduction/CreateCostReduction'), // 创建降本审批
  viewCostReductionDetail: () => import('@/views/stockcontrol/costReduction/ViewCostReductionDetail'), // 降本审批详情
  moldInformation: () => import('@/views/stockcontrol/moldManagement/MoldInformation'), // 模具信息
  moldRefundTableList: () => import('@/views/stockcontrol/moldManagement/MoldRefundTableList'), // 模具返款
  createMoldRefund: () => import('@/views/stockcontrol/moldManagement/CreateMoldRefund'), // 创建模具返款信息或编辑
  viewMoldRefuldDetail: () => import('@/views/stockcontrol/moldManagement/ViewMoldRefuldDetail'), // 模具返款详情
  shippingList: () => import('@/views/stockcontrol/ShippingList'), // 出货列表
  productionAnalysis: () => import('@/views/stockcontrol/ProductionAnalysis'), // 销售异常商品
  commodityDemandPlan: () => import('@/views/stockcontrol/CommodityDemandPlan'), // 商品需求计划
  commodityDemandPlanEntry: () => import('@/views/stockcontrol/CommodityDemandPlanEntry'),
  commodityPSI: () => import('@/views/stockcontrol/CommodityPSI'),
  fcstApplicationDetail: () => import('@/views/stockcontrol/FcstApplication/Detail'),
  stopProduction: () => import('@/views/stockcontrol/stopProduction/index'),
  fcstApplication: () => import('@/views/stockcontrol/FcstApplication/index'),
  quartileSafetyStock: () => import('@/views/stockcontrol/QuartileSafetyStock/index'),
  outCostCompare: () => import('@/views/stockcontrol/outCostCompare'),
  productionPlanTableList: () => import('@/views/stockcontrol/ProductionPlanList/index.vue'), // 生产计划
  productionPlanSummary: () => import('@/views/stockcontrol/ProductionPlanSummary'), // 生产计划汇总
  rawMaterialPackagingMaterials: () => import('@/views/stockcontrol/RawMaterialPackagingMaterialsList/index') // 原料包材净需求报表

}

export default map
